import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";

type OfferProps = {
  offerContent?: any;
};
function T1_Offers(props: OfferProps) {
  const { offerContent } = props;
  return (
    <Stack
      sx={{
        p: "20px",
        border: "1px solid var(--primary_color)",
        borderRadius: "20px",
        background: "var(--white)",
        width: "70%",
        mx: "auto",
        my: { md: "-25px" },
        mt: { xs: "20px" },
        position: { md: "absolute" },
        top: { md: "600px" },
        left: { md: "50%" },
        transform: { md: "translate(-50%, -50%)" },
      }}
    >
      <Grid container spacing={2}>
        {offerContent?.offers.map((data: any, index: number) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Typography
              component={"div"}
              sx={{
                p: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "left", md: "center" },
              }}
            >
              <Box
                component={"img"}
                src={data?.logo?.data.attributes.url}
                alt={data?.logo?.data.attributes.alternativeText}
                sx={{
                  marginRight: "5px",
                }}
              />
              <Typography
                component={"span"}
                sx={{
                  fontFamily: "var(--font_family_Medium)",
                  color: "var(--text_color)",
                  fontSize: "16px",
                }}
              >
                {data.item}
              </Typography>
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}

export default T1_Offers;
